import { render, staticRenderFns } from "./FormVacancyStudent.vue?vue&type=template&id=59a5efec"
import script from "./FormVacancyStudent.vue?vue&type=script&lang=js"
export * from "./FormVacancyStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports